/******************************************************************************
 *                                                                            *
  *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { FormFeedback, Label, Input } from 'reactstrap'

import {AppContext} from '../AppContext';

class PasswordWidget extends React.Component
{

  revealPasswordDisabled = false;
  passwordTimer = null;
  passwordScore = 0;

  componentWillUnmount()
  {
    if (this.passwordTimer) clearTimeout(this.passwordTimer);
  }

  constructor(props)
  {
    super();

    let passwordType = props.passwordType === undefined ? 'password' : props.passwordType;

    this.revealPasswordDisabled = props.passwordType === 'text' ? true : false;

    this.state =
    {
      passwordType: passwordType,
      revealPassword: false
    }

    this.hidePassword = this.hidePassword.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.togglePasswordReveal = this.togglePasswordReveal.bind(this);
  }

  getPasswordStrength(zxcvbn)
  {
// Different color scheme: #D9534F, #F28F68, #E3CB00, #8BCF69, #008000

    if (undefined === zxcvbn) return null;

    var strength = {'backgroundColor': '#FF5353', height: '5px', background: "#FF5353", width: "0%"};
    
    if (zxcvbn.score === this.context.websiteProfile.passwordStrength)
    {
      strength.background = "#8BCF69";
      strength.width = "99%";
    }
    else if (zxcvbn.score === 0)
    {
      strength.background = "#FF5353";
      strength.width = "15%";
    }
    else if (zxcvbn.score === 1)
    {
      strength.background = "#F28F68";
      strength.width = "30%";
    }
    else if (zxcvbn.score === 2)
    {
      strength.background = "#FAD054";
      strength.width = "50%";
    }
    else if (zxcvbn.score === 3)
    {
      strength.background = "#93C9F4";
      strength.width = "70%";
    }
    else if (zxcvbn.score === 4)
    {
      strength.background = "#8BCF69";
      strength.width = "99%";
    }

    return strength;
  }

  hidePassword(element)
  {
    this.setState({passwordType: 'password', revealPassword: false});
    this.passwordTimer = null;
  }

  onKeyDown(event)
  {
    if (window.enterKeyPressed(event.keyCode) && !this.props.buttonDisabled && undefined !== this.props.login)
    {
      this.props.login(event);
    }
  }

  render()
  {
    let strength = this.getPasswordStrength(this.props.score);

    let revealPassword = this.revealPasswordDisabled ? null : (<div style={{paddingTop: '10px'}}>
      <Label for='revealPassword'>Show Password:&nbsp;&nbsp;</Label>
      <Input id='revealPassword' style={{marginLeft: 0}} onChange={this.togglePasswordReveal} 
        checked={this.state.revealPassword ? "checked" : ''} type="checkbox"/></div>
    );

    return(  
      <div style={{display: 'flex', flexWrap: 'wrap'}}>
        <Input type={this.state.passwordType} autoComplete="off" value={this.props.value} placeholder={this.props.placeholder} 
          onChange={this.setPassword} disabled={undefined === this.props.disabled ? false : this.props.disabled} 
          invalid={( undefined ===  this.props.passwordValid ? undefined : !this.props.passwordValid)} 
          valid={( undefined ===  this.props.passwordValid ? undefined : this.props.passwordValid)} 
          onKeyDown={this.onKeyDown} id={this.props.id} autoFocus={this.props.focus} />
        {revealPassword}
        <div id="passwordStrength" style={strength} ></div>                
        <FormFeedback valid={false}>{this.props.passwordFB}</FormFeedback>
      </div>
    );
  }

  setPassword(event)
  {
    this.props.onChange(event.target.value);
  }

  togglePasswordReveal()
  {
    let revealPassword = !this.state.revealPassword; 
    if (revealPassword) 
    { 
      this.setState({passwordType: 'text', revealPassword});
      this.passwordTimer = setTimeout(this.hidePassword, window.passwordRevealTimeout); 
    } 
    else 
      this.setState({passwordType: 'password', revealPassword}); 
  }     
}

PasswordWidget.contextType = AppContext;

export default PasswordWidget